export default __webpack_public_path__ + "static/media/email_white.202e0f35.svg";